import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../../lib/styles';

import BreakdownBlockStyles from './BreakdownBlock_styles';
import Typography from '../../../../../components/presentational/Typography';

interface Breakdown {
  title: string;
  content: string;
}

export interface BreakdownBlockData {
  type: 'breakdown_block';
  title?: string;
  subtitle?: string;
  imageURL?: string;
  breakdowns: Breakdown[];
}

export interface BreakdownBlockProps {
  block: BreakdownBlockData;
}

const BreakdownBlock = ({
  block: { title, subtitle, breakdowns },
  styles,
}: BreakdownBlockProps & StylesProps<typeof BreakdownBlockStyles>) => (
  <div className={styles.panel}>
    <div className={styles.container}>
      {(title || subtitle) && (
        <div className={styles.headings}>
          {title && (
            <Typography>
              <h1>{title}</h1>
            </Typography>
          )}
          {subtitle && (
            <Typography weight={'normal'}>
              <h3 dangerouslySetInnerHTML={{ __html: subtitle }} />
            </Typography>
          )}
        </div>
      )}

      <div className={styles.image} />
      <div className={styles.breakdowns}>
        {breakdowns.map(({ title, content }, i) => (
          <Typography key={i} className={styles.breakdown}>
            <h5>
              <strong>{title}</strong>
            </h5>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Typography>
        ))}
      </div>
    </div>
  </div>
);

export default compose(styled(BreakdownBlockStyles))(BreakdownBlock);
